import dayjs from 'dayjs';
import 'dayjs/locale/uk';

dayjs.locale('uk');
